import React, {useEffect} from 'react'
import {useLocation} from "react-router";
import {useRecoilValue, useResetRecoilState, useSetRecoilState} from 'recoil'
import {useSecurityQueryData} from "src/hooks/reactquery"

import InputForm from "src/component/common/CommonForm/InputForm"
import useSubscriptQuery from "src/hooks/useSubscriptQuery"
import useValid from "src/hooks/useValid"

import {COLOR} from "src/service/constant/color"
import {ModalBtn} from "src/styles/common/CommonForm/buttonform"
import {TYPE_SECURITY,} from "src/service/constant/cmdtype"
import {ModalConfirmContent, ModalDefaultTitle} from "src/styles/common/modal"
import {SecurityContent, SecurityWrap} from "src/styles/common/sercurity";
import {SecurityNumState, SecurityTranIdState} from "src/store/recoil/common"
import reloadImg from "src/assets/common/reload.png"
import useOnInput from "src/hooks/useOnInput";

const SecurityModal = (props: any) => {
    const {isOpen, ClickFunc, ClickFunc2, ClickFunc3} = props //ClickFunc: toggle() ClickFunc2: douToggle()
    const {pathname} = useLocation()
    const onInput = useOnInput()
    const valid = useValid()
    const SecurityNum = useRecoilValue(SecurityNumState)
    const ResetSecurityNumState = useResetRecoilState(SecurityNumState)
    const setSecurityTranId = useSetRecoilState(SecurityTranIdState)
    const {data: SecurityData, mutate: SecurityReceive} = useSecurityQueryData(TYPE_SECURITY)
    const subscript = useSubscriptQuery()
    
    const SecurityConfirmFunc = () => {
        switch(pathname){
            case "/join": 
                subscript.joinSecureSubmit(ClickFunc2, ClickFunc)
                break
            case "/cancel": 
                subscript.cancelSecureSubmit(ClickFunc2, ClickFunc)
                break
            case "/refund": 
                subscript.refundSecureSubmit(ClickFunc2, ClickFunc, ClickFunc3)
                break
        }
    }
    useEffect(() => {
        SecurityData?.Body?.TranID && setSecurityTranId(SecurityData?.Body?.TranID)
    }, [SecurityData?.Body?.TranID, SecurityReceive, setSecurityTranId])
    
    useEffect(() => {
        ResetSecurityNumState()
        SecurityReceive()
    }, [ResetSecurityNumState, SecurityReceive, isOpen])

    return (
        <>
            <ModalConfirmContent>
                <SecurityWrap>
                    <ModalDefaultTitle>하단의 보안문자를 입력하세요.</ModalDefaultTitle>
                    <SecurityContent>
                        <section>
                            {SecurityData?.Body?.ImgB64 &&
                                <img
                                    src={`data:image/png;base64, ${SecurityData?.Body?.ImgB64 && SecurityData?.Body?.ImgB64}`}
                                    alt='보안문자 이미지'
                                />}
                        </section>
                        <img src={reloadImg} alt='새로고침' onClick={() => SecurityReceive()}/>
                        <InputForm
                            title=''
                            valid={valid.SecurityValid}
                            placeholder='보안문자 입력'
                            value={SecurityNum}
                            oninput={onInput.SecurityNum}
                            blurFunc={valid.onBlurForValidationCert}
                            errMsg="보안문자 입력을 확인해주세요."
                        />
                    </SecurityContent>
                    <p>※ 화면에 출력된 문자를 정확하게 입력 해 주세요.</p>
                </SecurityWrap>
                <section>
                    <ModalBtn bgColor={COLOR.blueGray3} onClick={ClickFunc}>
                        <span>취소</span>
                    </ModalBtn>
                    <ModalBtn bgColor={COLOR.point1} onClick={SecurityConfirmFunc}>
                        <span>확인</span>
                    </ModalBtn>
                </section>
            </ModalConfirmContent>
        </>
    )
}
export default SecurityModal
